import { FC } from 'react'
import css from 'styled-jsx/css'
import { convertImgLink, getCurrency, useCdnBasePath } from '@ui/helpers'
import { useSetting } from '@ui/hooks'

interface IVariant {
  size?: 'small' | 'normal'
  variant: Types.OrderLine
  title: string
}

const TrackingVariant: FC<IVariant> = ({ size, variant, title }) => {
  const [sellpageSetting] = useSetting('sellpage')
  const basepath = useCdnBasePath()
  function getImageSize() {
    switch (size) {
      case 'small':
        return 'is-4-mobile is-4-tablet is-2-desktop'
      case 'normal':
        return 'is-4-mobile is-4-tablet is-3-desktop'
      default:
        return 'is-4'
    }
  }

  return (
    <>
      <style jsx>{style}</style>
      <div className="variant">
        <div className="variant--top columns is-mobile is-variable is-2">
          <div className={`column ${getImageSize()}`}>
            <figure className="variant__image image is-square">
              {variant?.variant_image?.includes('_400x400') ? (
                <video autoPlay loop muted playsInline className="">
                  <source
                    src={convertImgLink(variant?.variant_image || '', basepath)}
                    type="video/mp4"
                  />
                </video>
              ) : (
                <img src={variant?.variant_image} alt="variant product" />
              )}
            </figure>
          </div>
          <div className="column">
            <div className="columns is-vcentered is-variable is-2 mb-0">
              <div className="column pb-1-mobile">
                {variant.status === 'CANCEL' && <span className="variant--canceled">Canceled</span>}
                {variant.status === 'PARTIAL_CANCEL' && (
                  <span className="variant--canceled">
                    Partially Canceled
                    {variant.cancel_quantity && `(-${variant.cancel_quantity})`}
                  </span>
                )}
                <div className="variant__title">{title}</div>
                <div className="size--small">
                  <div className="variant__property expand-on-mobile">
                    <p className="property mr-0">
                      {(variant.variant_properties ?? []).map((property, index) => {
                        return (
                          <span
                            key={index}
                            className={
                              index != Object.keys(variant.variant_properties ?? {}).length - 1
                                ? 'mr-6'
                                : ''
                            }
                          >
                            <strong>{property.name}</strong>: {property.value}
                          </span>
                        )
                      })}
                    </p>
                    <div className="property">
                      <strong>Quantity</strong>: {variant.quantity}
                    </div>
                  </div>

                  <div className="variant__price">
                    {variant.compared_price &&
                    !sellpageSetting?.settings?.configurations.hide_clearance ? (
                      <del className="compared">{getCurrency(variant.compared_price)}</del>
                    ) : null}
                    {getCurrency(variant.unit_price ?? 0)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="variant__quantity mobile">
          <div className="variant__price is-pulled-right">
            <del className="compared">{getCurrency(variant.compare_price ?? 0)}</del>
            {getCurrency(variant.price ?? 0)}
          </div>
        </div> */}
      </div>
    </>
  )
}

export default TrackingVariant

const style = css`
  .variant {
    &--top {
      margin-bottom: -12px !important;
    }

    &--canceled {
      font-size: 12px;
      line-height: 24px;
      color: #eb5757;
      font-weight: 600;
    }

    &__image {
      border: solid 1px #e8e8e8;
      border-radius: 5px;

      img {
        border-radius: 4px;
      }
    }

    &__title {
      font-size: 16px;
      line-height: 24px;
      font-weight: bold;
      margin-bottom: 8px;

      //@media screen and (max-width: 768px) {
      //  font-size: 15px;
      //}
    }

    &__property {
      display: block;
      font-size: 12px;
      line-height: 24px;
      text-transform: capitalize;

      .property--break-line {
        flex-basis: 100%;
        height: 0;
      }
    }

    &__remove {
      float: right;

      @media screen and (max-width: 768px) {
        float: initial;
      }

      .button {
        font-size: 12px;
        line-height: 18px;
        padding: 0;

        &:hover {
          background-color: transparent;
        }
      }
    }

    &__quantity {
      align-items: center;
      justify-content: space-between;

      @media screen and (max-width: 786px) {
        &.desktop {
          display: block;

          &.is-flex {
            display: none !important;
          }
        }

        &.mobile {
          display: none;

          .is-flex {
            display: flex;
          }
        }
      }

      @media screen and (min-width: 787px) {
        &.desktop {
          display: block;
        }

        &.mobile {
          display: none !important;
        }
      }
    }

    &__price {
      font-size: 16px;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;

      .compared {
        font-size: 12px;
        margin-right: 14px;
        color: var(--grey);
      }
    }

    &--cancel {
      display: flex;
      flex-direction: column;

      .variant__image {
        border-bottom: none;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }

      .tag {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        font-size: 10px;
      }
    }

    .expand-on-mobile {
      margin-right: -6rem !important;
    }
  }

  .size {
    &--small {
      display: flex;
      justify-content: space-between;
    }
  }
`
